import React from 'react';
import Home from './components/Home';
import Reddit from './components/Reddit';
import Portfolio from './components/Portfolio'
import { BrowserRouter , Route , Switch } from 'react-router-dom';
import Contact from './components/Contact';
import About from './components/About';



function App() {
  return (
      <BrowserRouter>
          <Switch>
            
            <Route path='/about' component={About}/>
            <Route path='/contact' component={Contact}/>
            <Route path='/portfolio' component={Portfolio}/>
            <Route  path='/' component={Home}/>
          </Switch>
      </BrowserRouter>
    
  );
}

export default App;
